import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import Menu from './Menu';
import SignOutButton from './SignOutButton';
import { fetchToken } from './Auth';
import { fetchSelfUserInfo } from './Auth';

export default function Header() {
  return (
    <>
      <header>
        <Navbar bg="light">
          <Container className="logo">
            <Navbar.Brand href="https://www.konicaminolta.com/" target='_blank'>
              <img src="/manager/identity01g.svg" />
            </Navbar.Brand>
          </Container>
        </Navbar>
        <Navbar bg="light">
          <Container className="logo-image">
            <Navbar.Brand href="/manager/">
              <img src="/manager/original.svg" />
            </Navbar.Brand>
            <Navbar.Collapse className="justify-content-end">
              <SignOutButton></SignOutButton>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {fetchToken() ? <Menu userInfo={fetchSelfUserInfo()}></Menu> : <div></div>}
      </header>
    </>
  );
}
